<script lang="ts">
    import { type TagNodeTree } from '$lib/bbcode/parser/types';
    import BBCodeNodes from '$components/BBCode/BBCodeNodes.svelte';
    import BBCodeNode from '$components/BBCode/BBCodeNode.svelte';

    export let nodes: TagNodeTree;
</script>

{#if nodes != null}
    {#if Array.isArray(nodes)}
        <BBCodeNodes {nodes} let:slotName let:slotContent>
            <slot {slotName} {slotContent} />
        </BBCodeNodes>
    {:else}
        <BBCodeNode node={nodes} let:slotName let:slotContent>
            <slot {slotName} {slotContent} />
        </BBCodeNode>
    {/if}
{/if}
